import { createContext, RefObject, useContext } from 'react';

export interface NewMessagesAnchorValue {
  anchor: string | null;
  anchorRef: RefObject<string | null>;
  setAnchor: (value: string | null) => void;
}

const EMPTY_VALUE: NewMessagesAnchorValue = {
  anchor: null,
  anchorRef: { current: null },
  setAnchor: () => undefined,
};

export const NewMessagesAnchorContext = createContext<NewMessagesAnchorValue>(EMPTY_VALUE);

export function useNewMessagesAnchor(): NewMessagesAnchorValue {
  return useContext(NewMessagesAnchorContext);
}
